import styled from 'styled-components';
import { InputField } from '..';

export const DadosRetorno = styled(InputField)`
  border-radios: 20px !important;
  padding: 20px;
`;
